import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import validationEngine from 'devextreme/ui/validation_engine';
import { TimeCategory } from 'src/app/core/data/entities';

@Component({
    selector: 'app-time-dialog',
    templateUrl: './time-dialog.component.html',
    styleUrls: ['./time-dialog.component.scss'],
    standalone: false
})
export class TimeDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    entity: any;
    jobId: number;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';
    minDate: Date;

    constructor(
        public modalRef: BsModalRef,
        private uow: RAFUnitOfWork,
        private appInfo: AppInformationService,
        private auth: AuthenticationService
    ) {}

    async ngOnInit() {
        this.entity = this.uow.timeEntries.createEntity();
        this.entity.jobId = this.jobId;
        this.entity.created = moment(new Date()).startOf('day').toDate();
        this.minDate = moment(new Date()).add(-10, 'days').toDate();
        this.entity.employeeId = this.auth.userValue.employeeId;
        this.entity.timeCategoryId = TimeCategory.Categories.Hourly;
    }

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;
        this.result.next({ success: true });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }

        return true;
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}
